<template>
	<div class="view" :style="{height:fixedHeight+'px'}">
		<!-- 筛选 -->
		<div class="filter">
      <el-select v-model="petType" placeholder="种类" class="titleSelect" style="width: 188px;"
							size="small" @change="handelApplyChange"> 
							<el-option v-for="item in applyTypes" :key="item.value" :label="item.label"
								:value="item.value" />
						</el-select>
      <el-select v-model="category"  placeholder="品种" size="small">
					<el-option v-for="item in breedOptions" :key="item._id" :label="item.name"
								:value="item._id">
					</el-option>
			</el-select>
			<el-button type="warning" @click="getTableData" size="small">查询</el-button>
      <el-button type="warning" @click="getReset" size="small">重置</el-button>
		</div>
		<!-- 表格 -->
		<el-table :data="tableData" ref="multipleTable" style="width: 100%" class="deathTable" tooltip-effect="dark"
    @selection-change="handleSelectionChange">
      <el-table-column
      type="selection"
      width="55">
    </el-table-column>
			<el-table-column prop="petType" label="种类">
			</el-table-column>
			<el-table-column prop="category" label="品种">
				<!-- <template slot-scope="scope">
					<el-tooltip class="item" effect="dark" :content="formartCate(scope.row.joinCategory)" placement="right">
						<span>{{scope.row.joinCategory.length}}<i class="el-icon-view" style="color:#F5882A;margin-left: 4px;"></i></span>
					</el-tooltip>
				</template> -->
			</el-table-column>
      <el-table-column prop="color" label="颜色">
			</el-table-column>
			<el-table-column label="建议库存">
				<template slot-scope="scope">
					{{scope.row.suggestStock}}
          	<el-button type="text" size="small" @click="hanelEditClick(scope.row)">编辑</el-button>
				</template>
			</el-table-column>
      <el-table-column prop="stock" label="现有库存">
			</el-table-column>
			<el-table-column label="北环">
				<template slot-scope="scope">
					{{scope.row.bhg+scope.row.bhm}}
				</template>
			</el-table-column>
      <el-table-column label="二七">
				<template slot-scope="scope">
					{{scope.row.eqg+scope.row.eqm}}
				</template>
			</el-table-column>
      <el-table-column label="云尚">
				<template slot-scope="scope">
					{{scope.row.ysg+scope.row.ysm}}
				</template>
			</el-table-column>
			<el-table-column prop="needAdd" label="需要补充库存">
			</el-table-column>
			<!-- <el-table-column label="操作" align="center">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="hanelEditClick(scope.row)">编辑</el-button>
					<el-button type="text" size="small" @click="hanelDeleteClick(scope.row.id)">删除</el-button>
				</template>
			</el-table-column> -->
		</el-table>
    <div style="margin-top: 20px">
    <el-button @click="toggleSelection()">取消选择</el-button>
    <el-button @click="hanelEditNumClick()">批量编辑</el-button>

  </div>
		<!-- 分页 -->
		<page :total="page.total" @change="changePage" style="margin-top: 22px;"></page>
		<!-- 新建和更新 -->
		<el-drawer title='任务设置' :modal='false' size='40%' :visible.sync="drawer" custom-class='drawersend'
			direction="rtl">
			<div class="drawerView">
				<div class="msg">
				</div>
				<div class="drawerBtn">
					<div @click="handelCanelClick">取消</div>
					<div @click="handelConfirmClick">{{edit == null?'添加':'更新'}}</div>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import page from "@/components/page.vue"
	import {
		breed,
		updatePlan,deletePlan
	} from "@/api/purchaseApi.js"
	export default {
		components: {
			page
		},
		data() {
			return {
				page: {
					page: 1,
					pageSize: 10,
					total: 0
				},
				fixedHeight: '', //模型高度
				tableData: [],
				keyword: '', //搜索
				drawer: false, //弹框
				petType: '猫', //分类数据
        petTypeClass:'',
				applyTypes: [{
					value: '猫',
					label: '猫类'
				}, {
					value: '犬',
					label: '犬类'
				}],
				taskName: '', //任务名称
				category: '', //品种
				breedOptions: [], //品种列表
				times: 1, //次数
				planWay: '', //任务方式
				plans: [{
					value: '1',
					label: '每日'
				}, {
					value: '2',
					label: '每周'
				}, {
					value: '3',
					label: '每月'
				}, ],
				required: 1, //必填项
				remark:'',  //备注
				edit:null,  //编辑信息
				comDate:'',  //时间
        multipleSelection: [], //多选
			}
		},
		created() {
			this.fixedHeight = document.documentElement.clientHeight - 106;
		},
		mounted() {
			this.getTableData()
     this.getBreedData()
		},
		methods: {
      toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
			//编辑
			hanelEditClick(row){
				this.edit = row;
				this.drawer = true;
				console.log(row)
				this.applyType = row.applyType.value;
				this.getBreedData()
				this.taskName = row.taskName;
				this.planWay = row.planWay.value;
				this.times = row.times;
				this.required = row.required?1:0;
				this.remark = row.remark;
				this.comDate = [new Date(Number(row.startTime) * 1000),new Date(Number(row.endTime) * 1000)]
				let arr = []
				for (let i = 0; i < row.joinCategory.length; i++) {
					arr.push(row.joinCategory[i]._id)
				}
				this.breed = arr;
			},
      // 批量编辑
      hanelEditNumClick(){

      },
			//删除
			// hanelDeleteClick(id){
			// 	this.$confirm('是否删除该任务？', '提示', {
			// 		confirmButtonText: '确定',
			// 		cancelButtonText: '取消',
			// 		type: 'warning'
			// 	}).then(() => {
			// 		let params = {
			// 			id:id
			// 		}
			// 		deletePlan(params).then((res)=>{
			// 			if(res.code == 0){
			// 				this.$message({
			// 					type: 'success',
			// 					message: '已删除'
			// 				});
			// 				this.getTableData()
			// 			}
			// 		})
			// 	}).catch(() => {
			// 		this.$message({
			// 			type: 'info',
			// 			message: '已取消删除'
			// 		});          
			// 	});
			// },
			//格式化
			formartCate(data){
				console.log(data)
				let str = ''
				for (let i = 0; i < data.length; i++) {
					str = str +data[i].name +' '
				}
				return str
			},
			//弹框确认
			handelConfirmClick(){
			
				console.log(this.breed)
				let params = {
					applyType:this.ƒ,
					taskName:this.taskName,
					planWay:this.planWay,
					times:this.times,
					remark:this.remark
				}
				if(this.required == 1){
					params.required = true
				}else{
					params.required = false
				}
				let arr = [];
				for (let i = 0; i < this.category.length; i++) {
					for (let j = 0; j < this.breedOptions.length; j++) {
						if(this.category[i] == this.breedOptions[j]._id){
							arr.push(this.breedOptions[j])
						}
					}
				}
				if(this.edit != null){
					params.id = this.edit.id
				}
				params.joinCategory = arr;
				if(this.comDate != ''){
					params.startTime= new Date(this.comDate[0]).getTime() / 1000;
					params.endTime= new Date(this.comDate[1]).getTime() / 1000;
				}
				console.log(params)
				updatePlan(params).then((res)=>{
					if(res.code == 0){
						if(this.edit == null){
							this.$message({
								type: 'success',
								message: '添加成功'
							});
						}else{
							this.$message({
								type: 'success',
								message: '更新成功'
							});
						}
						
						this.drawer = false;
						this.getTableData()
					}
				})
			},
			//切换种类
			handelApplyChange(){
				this.category = '';
				this.getBreedData()
			},
			//弹框取消
			handelCanelClick(){
				this.drawer = false;
				this.applyType = '1';
				this.taskName = '';
				this.planWay = '';
				this.times = 1;
				this.required = 1;
				this.remark = '';
				this.category = '';
			},
			//获取品种
			getBreedData() {
        console.log(this.petType,"petType");
        if(this.petType=='猫'){
          this.petTypeClass='1'
        }else if(this.petType=='狗'){
          this.petTypeClass='2'
        }
				let that = this;
				let params = {
					applyType: this.petTypeClass
				}
				breed(params).then((res) => {
					if (res.code == 0) {
						console.log('品种', res)
						that.breedOptions = res.data;
					}
				})
			},
			//获取数据
			getTableData() {
				let params = {
					pageIndex: this.page.page,
					pageSize: this.page.pageSize,
					keyword: this.keyword,
          petType:this.petTypeClass,
          category:this.category,
				}
        // /api/product/pet/stock/warninglist
        let loading = this.$loading();
      this.$http
        .get(
          process.env.VUE_APP_Url_8000 + "/api/product/pet/stock/warninglist",
          params
        )
        .then((res) => {
          loading.close();
					if (res.code == 0) {
						console.log('配置列表', res)
						this.tableData = res.data;
						this.page.total = res.data.count;
					}
				})
			},
			//分页方法
			changePage(num) {
				this.page.page = num;
				this.getTableData();
			},
      getReset(){
        this.applyType='',
        this.category=''
      }
		}
	}
</script>

<style lang="scss" scoped>
	.view {
		min-height: 852px;
		min-width: 1276px;
		background: #fff;
		font-family: PingFangSC-Regular, PingFang SC;

		.filter {
			height: 58px;
			display: flex;
			align-items: center;

			.sousuo {
				width: 153px;
				margin-right: 4px;
				margin-left: 16px;
			}

			.filterName {
				margin-left: 20px;
				margin-right: 4px;
			}
		}

		.drawerView {
			display: flex;
			flex-direction: column;
			height: 100%;

			.msg {
				flex: 1;
				padding: 0 20px;

				.item {
					display: flex;
					align-items: center;
					margin-bottom: 16px;

					.itemName {
						margin-right: 12px;
					}
				}
			}

			.drawerBtn {
				cursor: pointer;
				display: flex;
				height: 40px;
				line-height: 40px;
				font-size: 14px;

				div:nth-of-type(1) {
					text-align: center;
					flex: 1;
					background: #E4E4E4;
					color: #666;
				}

				div:nth-of-type(2) {
					flex: 1;
					text-align: center;
					background: #F5882A;
					color: #fff;
				}
			}
		}
	}
</style>
